/**
 * Created by anthony on 2/7/14.
 */
bin.classy.controller({
    name: 'BinController',
    inject: ['$scope', '$sce', '$timeout', '$location', '$stateParams', '$anchorScroll', '$modal', 'AppModelService', 'ApplicantModelService', '$q',
        'authServiceFactory', 'BinFactory', 'SchoolSubcategoriesModelService', 'ApplicationService', 'DetermineAwardService', 'AccountModelService', 
        'AccountModelService', 'BinService', 'BinSummaryService', 'ApplicationsSubNavbarService', 'PermissionModelService', 'BudgetsModelService',
        'SchoolModelService'],
    init: function()
    {
        this.$.filter = {};
        this.$.stateParams = this.$stateParams;
        this.$.BinFactory = this.BinFactory;
        this.$.BinService = this.BinService;
        this.$.BinSummaryService = this.BinSummaryService;
        this.$.ApplicationsSubNavbarService = this.ApplicationsSubNavbarService;  
        this.$.Math = Math;

        this.$.accounts = this.AccountModelService.get();
        this.$.categories = this.SchoolSubcategoriesModelService.get();
        this.BinService.updateFilter("taxFilter");
        this.BinService.updateFilter("gradeFilter");
        this.BinService.updateFilter("NRFilter");
        this.BinService.updateFilter("SubCatsFilter");
        this.BinService.updateFilter("accountsFilter");
        this.$.faculty = this.authServiceFactory.getAuth().permissions.faculty;
        this.$.budgetPutObject = [];

        this.resizeAppList = function(open) {
            if (!open) var top = $('.search-box').outerHeight();
            else var top = $('.search-box').outerHeight() + $('.applicant-filters').height() + 16;
            $('.applicant-list').animate({'top': top},0);
        }
        $(window).resize(this.resizeAppList(this.$.masseditopen));
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.appFilter = '';
    },
    searchCallBack: function(ctrl)
    {
        ctrl.calculateTotalAwarded();
    },
    toTop: function()
    {
        if (this.$location.hash() !== 'app0')
            this.$location.hash('app0');
        else
            this.$anchorScroll();

    },
    sort: function(field)
    {
        var sort = this.BinService.getSort();
        if (sort.field.toString() == field.toString()) {
            sort.reverse = !sort.reverse;
        }
        else
        {
            sort.reverse = false;
            sort.field = field;
        }
        this.BinService.setSort(sort.field, sort.reverse)
    },
    calculateTotalAwarded: function()
    {
        /*
        var budget = this.showBudget();
        if ((typeof this.DataTableService.pagedItems !== 'undefined'))
        {
            this.$.application_total = 0;
            for (var i = 0; i < this.DataTableService.pagedItems[1].length; i++)
                if (budget == false)
                    this.$.application_total += parseInt(this.DataTableService.pagedItems[1][i].Applicant_Total);
                else
                    this.$.application_total += parseInt(this.DataTableService.pagedItems[1][i].budgets[budget]);
        }
        */
    },
    showBudget:function()
    {
        var ret = false;
        if (typeof this.BinService.filter['accountsFilter'] !== 'undefined')
        {
            for(var property in this.BinService.filter["accountsFilter"].values)
            {
                if (this.BinService.filter["accountsFilter"].values[property])
                    ret = property;
            }
        }
        return ret;
    },
    showGrade:function()
    {
        var ret = false;
        if (typeof this.BinService.filter['gradeFilter'] !== 'undefined')
        {
            for(var property in this.BinService.filter["gradeFilter"].values)
            {
                if (this.BinService.filter["gradeFilter"].values[property])
                    ret = property;
            }
        }
        return ret;
    },
    isInBudget: function(app, applicantIndex) {
        var applicantID = app.ApplicantIDs[applicantIndex];
        var noBudgets = true;
        for (let budgetID in this.BinService.filter["accountsFilter"].values) {
            if (this.BinService.filter["accountsFilter"].values[budgetID]==true) {
                noBudgets = false;
                for (let applBudgetID in app.budgetApplicants[applicantID]) {
                    if (app.budgetApplicants[applicantID][applBudgetID]==budgetID)
                        return true;
                    else
                        return false;
                }

            }
            if (noBudgets) 
                return true;
        }
        return true;
    },
    isInGrade: function(app, applicantGrade) {
        let noFilter = true;
        let obj = this.BinService.filter.gradeFilter.values;
        let keys = Object.keys(obj);
        let filtered = keys.filter((key) => {
            return obj[key];
        });
        filtered.forEach((v, i) => {
            filtered[i] = filtered[i].split("-")[0];
        });

        for (let key in this.BinService.filter.gradeFilter.values) {
            if (this.BinService.filter.gradeFilter.values[key] === true) {
                noFilter = false;
            }
        }
        if (noFilter === true) {
            return true;
        } else {
            let i = filtered.length;
            while (i--) {
                if (applicantGrade === filtered[i]) {
                    return true;
                }
            }
        }
    },
    calcAward: function(app)
    {
        var sum = 0;
        for (var i = 0; i < app.Applicants.length; i++) {
            if (this.isInGrade(app, i)==true) {
                sum += parseInt(app.ActAwards[i]);
            }
        }
        return sum;
    },
    isFilter: function()
    {
        var count = 0;
        if (this.orObject(this.BinService.filter.gradeFilter.values)) {
            count++;
        }
        if (this.orObject(this.BinService.filter.accountsFilter.values)) {
            count++;
        }
        return count;
    },
    orObject: function(obj) {
        let sum = false;
        for (let el in obj) {
            sum = sum || obj[el];
        }
        return sum;
    },
    stopPropagation:function(event)
    {
        event.stopPropagation();
    },
    clearSearch: function() {

        this.$.BinService.appFilter = "";

    },
    buildBudgetPutObject: function(applicants) {
        for (var i = 0; i < applicants.length; i++)
        {
            this.$.budgetPutObject[i] = {};
            for (var j = 0; j < applicants[i].budgets.length; j++)
            {
                var accountID = applicants[i].budgets[j].accountID;
                this.$.budgetPutObject[i][accountID] = {};
                this.$.budgetPutObject[i][accountID].schoolID = this.authServiceFactory.getAuth().schoolID;
                this.$.budgetPutObject[i][accountID].applicationID = this.ApplicationService.getAwardData().app[0].applicationID;
                this.$.budgetPutObject[i][accountID].recordID = applicants[i].budgets[j].recordID;
                this.$.budgetPutObject[i][accountID].accountID = applicants[i].budgets[j].accountID;
                this.$.budgetPutObject[i][accountID].award = applicants[i].budgets[j].award; 
                this.$.budgetPutObject[i][accountID].applicantID = applicants[i].recordID;
            }

        }
    },
    setReject: function(app)
    {
        //Move to reject bin
        var parent = this;
        var putObject = { type: 'Reject', applicants: [] };
        var budgetObject = this.buildBudgetPutObject(app.applicants);
        for (var i = 0; i < app.applicants.length; i++) {
            putObject.applicants[i].Act_Award = 0;
        }
        putObject.type = "Reject";
        this.AppModelService.AwardApplicant(this.ApplicationService.getAwardData().app[0].applicationID, putObject).then(function() {
            parent.DetermineAwardService.setAwardComplete("Reject");
            //set budgets to 0 for rejection
            for (let i in parent.$.budgetPutObject) { //for each applicant
                for (let j in parent.$.budgetPutObject[i]) { //for each budget
                    parent.$.budgetPutObject[i][j].award = 0;
                }
            }
            parent.setBudget();
        });
    },
    quickAward: function(app, $event) {
        $event.stopImmediatePropagation();
        this.$modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/bin/partials/quickAwardModal.html?v=" + versionNo,
            controller: "QuickAwardController",
            resolve: {
                accounts: function(AccountModelService, authServiceFactory) {
                    return AccountModelService.resolveData();
                },
                app: function() {
                    return app;
                },
                budgets: function(BudgetsModelService) {
                    return BudgetsModelService.getFromApp(app.applicationID);
                }
            }
        });
        
    },
    searchByAlpha: function(alpha) {
        this.BinService.searchByAlpha(alpha);
        this.$timeout(function() {
            $("#dropdown-alpha button").click(); //hide dropdown menu
        }, 100);
    }
});

bin.directive('showonhoverparent',
    function() {
        return {
            link: function(scope, element, attrs) {
                element.parent().bind('mouseenter', function() {
                    element.show();
                });
                element.parent().bind('mouseleave', function() {
                    element.hide();
                });
            }
        }
    });
